/** @jsxImportSource @emotion/react */

import { Box, css } from '@mui/material';
import { useEffect, useState } from 'react';

const RadioSelectList = (props: { list: string[]; selected?: Function; design: string }) => {
  const { design, list, selected } = props;

  const [selectedBox, setSelectedBox] = useState<string>('All');

  const handleSelect = (color: string) => {
    setSelectedBox(color);
  };

  useEffect(() => {
    setSelectedBox('All');
  }, [design]);

  useEffect(() => {
    if (!!selected) {
      selected(selectedBox);
    }
  }, [selectedBox]);

  return (
    <Box css={style.root}>
      {list.map((l, i) => {
        return (
          <Box onClick={handleSelect.bind(this, l)} css={[style.radioBox, selectedBox === l ? style.selectedBox : {}]} key={i}>
            {l}
          </Box>
        );
      })}
    </Box>
  );
};

const style = {
  root: css`
    display: flex;
  `,
  radioBox: css`
    display: flex;
    border: 1px solid black;
    margin: 0 4px;
    padding: 4px 8px;
    border-radius: 4px;
    cursor: pointer;
    text-align: center;
    align-items: center;
    &:hover {
      box-shadow: 0px 0px 3px black;
    }
  `,
  selectedBox: css`
    background-color: #ffff0080;
  `,
};

export default RadioSelectList;
